import styled from 'styled-components';

export const NewsletterContainer = styled.div`
  width: 100%;
  /* padding: 1rem 2rem; */
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  p {
    font-style: italic;
    color: ${({ theme }) => theme.colors.grey1};
    padding-bottom: ${({ theme }) => theme.spacing.xs};
  }
  span {
    font-style: italic;
    color: ${({ theme }) => theme.colors.grey3};
    padding-top: ${({ theme }) => theme.spacing.xs};
  }
`;
export const NewsletterForm = styled.form`
  width: 95%;
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.m};
  gap: ${({ theme }) => theme.spacing.m};
  input {
    width: 50%;
  }
`;

export const NewsletterFormCentered = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.m};
  input {
    width: 40%;
  }
`;
